import { useSession } from '@side/next-auth/react';
import { useResolveUserIdentityId } from '@/common/hooks/useResolveIdentityId';

/**
 * core-service lets delegates *read* another user's integrations but rejects
 * every write against them with a 404, so a Google Contact action offered to
 * anyone but the owner can only ever fail.
 */
export function useIsGoogleContactOwner(
  ownerUserId: string | null | undefined,
) {
  const sessionUserId = useSession().data?.user?.id;

  // An owner id that already matches the session has nothing to resolve, and
  // waiting on the lookup anyway would hide the actions from the owner for a
  // whole round trip — or permanently, whenever the lookup comes back empty.
  const isSessionUser = !!ownerUserId && ownerUserId === sessionUserId;
  const { resolvedId } = useResolveUserIdentityId(
    isSessionUser ? null : ownerUserId,
  );

  if (!sessionUserId || !ownerUserId) return false;
  if (isSessionUser) return true;

  return !!resolvedId && resolvedId === sessionUserId;
}
